export const TEST_ID = 'panelActionFooter';
